export const pages = [
  { index: 0, name: 'overview.md', route: '/overview' },
  { index: 1, name: 'education.md', route: '/education' },
  { index: 2, name: 'projects.md', route: '/projects' },
  { index: 3, name: 'coursework.md', route: '/coursework' },
  { index: 4, name: 'books.md', route: '/books' },
  { index: 5, name: 'settings.tsx', route: '/settings' },
];
